import { ChangeEventHandler, useEffect, useState, FC } from "react";
import { ChainAssets, TokenInfo } from "./AssetsInterfaces"; 
import { Input } from "antd";

import "./chainAssetsItem.less";
import Search from "./search.png";
import ChainTokenItem from "./ChainTokenItem";
import Left from "../../images/left.png";
import Right from "../../images/right.png";
import { KeyboardEventHandler } from "react";

interface IProps {
    chainAssets: ChainAssets
}

const ChainAssetsItem: FC<IProps> = (props: IProps) => {
    const { chainAssets } = props
    const { chain, tokens } = chainAssets

    const [currentPage, setCurrentPage] = useState(0)
    const [userInput, setUserInput] = useState("")
    const [showInput, setShowInput] = useState(false)
    const [userInputOnFocus, setUserInputOnFocus] = useState(false)
    const [filteredAndSortedTokens, setFilteredAndSortedTokens] = useState<TokenInfo[]>([])
    const [currentDisplayedTokens, setCurrentDisplayedTokens] = useState<TokenInfo[]>([])

    useEffect(() => {
        let targetTokens: TokenInfo[] = []
        const filteredTokens = tokens.filter(tokenInfo => {
            if (userInput.length > 0) {
                const userInputWithout0x = userInput.replace("0x", "")
                if (tokenInfo.token.symbol.toLowerCase().includes(userInputWithout0x) || tokenInfo.token.address.toLowerCase().replace("0x", "").includes(userInputWithout0x)) {
                    return true
                } 
                return false
            }
            return true
        })

        // const USDC > USDT > WETH > DAI > WBTC 
        const usdc = filteredTokens.find(tokenInfo => { return tokenInfo.token.symbol.toLowerCase() === "usdc" })
        const usdt = filteredTokens.find(tokenInfo => { return tokenInfo.token.symbol.toLowerCase() === "usdt" })
        const weth = filteredTokens.find(tokenInfo => { return tokenInfo.token.symbol.toLowerCase() === "weth" })
        const dai  = filteredTokens.find(tokenInfo => { return tokenInfo.token.symbol.toLowerCase() === "dai" })
        const wbtc = filteredTokens.find(tokenInfo => { return tokenInfo.token.symbol.toLowerCase() === "wbtc" })

        if (usdc) {
            targetTokens.push(usdc)
        }

        if (usdt) {
            targetTokens.push(usdt)
        }
        
        if (weth) {
            targetTokens.push(weth)
        }
        
        if (dai) {
            targetTokens.push(dai)
        }
        
        if (wbtc) {
            targetTokens.push(wbtc)
        }

        const addedTokenSymbols = targetTokens.map(tokenInfo => {
            return tokenInfo.token.symbol
        })

        const restFilteredTokensWithAlphabetOrder = filteredTokens.filter(tokenInfo => {
            return !addedTokenSymbols.includes(tokenInfo.token.symbol)
        }).sort((tokenInfo1, tokenInfo2) => {
            if (tokenInfo1.token.symbol < tokenInfo2.token.symbol) {
                return -1;
            }
            if (tokenInfo1.token.symbol > tokenInfo2.token.symbol) {
                return 1;
            }
            return 0;
        })

        targetTokens = targetTokens.concat(restFilteredTokensWithAlphabetOrder)
        
        setFilteredAndSortedTokens(targetTokens)
    }, [tokens, userInput])

    useEffect(() => {
        if (filteredAndSortedTokens.length === 0) {
            setCurrentPage(0)
            setCurrentDisplayedTokens([])
            return 
        }

        setCurrentPage(1)
    }, [filteredAndSortedTokens])

    useEffect(() => {
        let start = (currentPage - 1) * 10
        let end  = currentPage * 10

        if (start >= filteredAndSortedTokens.length) {
            setCurrentPage(0)
            setCurrentDisplayedTokens([])
            return 
        } 

        if (end >= filteredAndSortedTokens.length) {
            end = filteredAndSortedTokens.length
        }
        setCurrentDisplayedTokens(filteredAndSortedTokens.slice(start, end))
    }, [filteredAndSortedTokens, currentPage])

    const showInputContainer = () => {
        setShowInput(true)
    }

    const onFocus = () => {
        setUserInputOnFocus(true)
    }

    const hideInputContainer = () => {
        if (userInputOnFocus) {
            setShowInput(false)  
            setUserInputOnFocus(false)
        }
    }

    const currentPageIncrease = () => {
        if ((currentPage * 10) >= filteredAndSortedTokens.length) {
            return 
        }

        setCurrentPage(currentPage + 1)
    }

    const currentPageDecrease = () => {
        if (currentPage < 2) {
            return 
        }

        setCurrentPage(currentPage - 1)
    }

    const onInputChange: ChangeEventHandler<HTMLInputElement> = (event) => {
        setUserInput(event.target.value.toLowerCase())
    }

    const onEnter: KeyboardEventHandler<HTMLInputElement> = (e) => {
   
    }
 
    return (
        <div className="item" key={props.chainAssets.chain.id}>
            <div className="row1">
                <img src={chain.icon} alt="" className="chain-icon" />
                <div className="chain-info">
                    <div className="chain-name">
                        {chain.name}
                    </div>
                    <div className="chain-token-count">
                        {tokens.length} Tokens
                    </div>
                </div>
            </div>
            
            {
                (showInput) ? ( 
                    <Input
                        className="input-box"
                        placeholder="Search token by name or address"
                        value={userInput}
                        onChange={onInputChange}
                        onPressEnter={onEnter}
                        onFocus = {onFocus}
                        onBlur = {hideInputContainer}
                        allowClear
                        autoFocus={true}/>
                ) : ( 
                    <div className="support-token-header">
                        <div className="support-token-header-title">
                            SUPPORTED TOKENS
                        </div>
                        <img src={Search} alt="" className="support-token-header-search" onClick={showInputContainer} />
                    </div>
                )
            }

           
            {
                (currentDisplayedTokens.length > 0) && (
                    <div className="token-item-list">
                    {
                        currentDisplayedTokens.map(tokenInfo => {
                            return <ChainTokenItem
                                        key={tokenInfo.token.symbol}
                                        chain={chain}
                                        tokenInfo={tokenInfo}
                                    />
                        })
                    }
                    </div>
                )
            }
            {
                (filteredAndSortedTokens.length === 0) && (
                    <div className="token-item-list-empty">
                        <div className="token-item-list-empty-description">
                        👀<br/><br/>No results for "{userInput}"
                        </div>
                    </div>
                )
            }
            {
                (filteredAndSortedTokens.length > 0) && (
                    <div className="page-selector-container">
                        <div className="page-selector">
                            <img className="left-icon" src={Left} alt = "" onClick={currentPageDecrease} />
                            <div className="page-number">{currentPage}</div>
                            <img className="right-icon" src={Right} alt = "" onClick={currentPageIncrease}/>
                        </div>
                    </div>
                )
            }
        </div>
    )
}

export default ChainAssetsItem;